<template>
  <div class="container">
    <h1 class="title">OTT Watchlist – Your Movie & TV Series Tracker</h1>
    <div class="articles-grid">
      <div class="article--item">
        <div class="body-area">
          <p>
            Need to know what’s on and where? We’ve got the perfect platform for
            that.
          </p>

          <p>
            We live in an era of streaming services with the likes of Netflix,
            Amazon Prime, and Hulu leading the pack, and it is common to hear
            people complain about missing shows or episodes. There’s a lot of tv
            shows to watch with new episodes airing every day and some shows
            getting slashed, it’s hard to keep track of all your TV shows and
            adding new ones to your list. OTT Watchlist is a Movie &amp; TV
            Series tracker designed to make sure you're up-to-speed with the TV
            shows you watch and even notify you for new episodes. Stay on top of
            the release schedule with our movie tracker app that lets you track
            your watched TV shows and movies, keep an eye on new releases,
            recommendations on new TV shows, and manage the media collection.
            OTT watchlist features a slick UI and packs plenty of functions like
            custom lists, comments, and detailed reviews. The OTT watchlist
            application available for <strong>android</strong> and
            <strong>IOS</strong> gives you all the features of OTT watchlist and
            real-time market updates on-the-go at your fingertips. OTT Watchlist
            gives you;
          </p>
          <ul>
            <li>
              Exhaustive catalog of tv shows, movies, and favorite
              actors/actresses
            </li>
            <li>
              Track and monitor your current watchlist and ongoing episodes
            </li>
            <li>Custom library of previously watched shows</li>
            <li>Personalized recommendations based on previous watchlists</li>
            <li>Critics tab to rate and vote on episodes and shows</li>
            <li>Comments, read reviews, and buzz feed on the vine</li>
            <li>
              After credits with quizzes, memes, polls, articles, and podcasts.
            </li>
            <li>Ott updates on new movies releases and episodes updated</li>
          </ul>
          <p>So, why choose the OTT Watchlist?</p>
          <h3>OTT platforms</h3>
          <p>
            Keep up with currently streaming content on OTT streaming platforms
            like Amazon, Hulu, Netflix, Disney+, and many more. Advanced filters
            and search algorithms let you browse by platform, and apply filters
            based on language, genre, etc. save time, watch better with
            personalized to-do movies and TV shows
          </p>
          <h3>OTT updates</h3>
          <p>
            Notifications of new arrivals on OTT updates complete with premiere
            dates and times so you never miss a moment. Create a personal
            watchlist of shows and movies before they air with streaming dates
            and upcoming releases categorized by genre and streaming platforms.
          </p>
          <h3>Kids</h3>
          <p>
            Whole family entertainment with the hottest and latest Kids TV
            shows, Kids Movies, and cartoons. GE and PG-rated films certified
            adult-free content and child-friendly show material. The parental
            controls give you the peace of mind knowing that all your TV shows
            are tucked away safely.
          </p>
          <h3>MustWatch</h3>
          <p>
            A one-stop-shop for carefully curated content featuring the top 50
            or 100 TV shows of all time, timeless masterpieces, and all-time
            favorite shows, and top 100 movies and TV shows recommendations
            across multiple languages based on your personal preferences. Get
            in-depth analysis and critics of your favorite TV shows while
            tracking your current shows and viewing progress.
          </p>
          <h3>MyWatchList</h3>
          <p>
            A comprehensive list of previously watched TV shows, movies, and
            episodes and your current watching progress. Create a personal to-do
            list of Tv shows, movies, and upcoming releases and look back at
            your last viewed episodes. Compare and match Movie recommendations,
            upcoming Tv shows, and new premieres according to statistics,
            reviews, and ratings of each
          </p>
          <h4>Articles</h4>
          <p>
            Keep up to speed with articles, unbiased reviews, and rumors about
            recommended, TV shows. MustWatch movies, entertainment news, and any
            other relevant information about your favorite episodes of any TV
            show and Movies on OTT streaming service.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    params: {
      articleId: ""
    },
    article: { title: "", author: "", date: "", content: "" }
  })
};
</script>

<style scoped>
.container {
  padding-top: 70px;
}
.title {
  margin-left: 15px;
  font-size: 35px;
}

.body-area {
  padding: 30px 20px 50px 20px;
  font-family: Calibri, sans-serif;
  font-size: 1.2rem;
}
.articles-grid {
  display: grid;
  grid-template-columns: 100%;
}

.body-area {
  color: #111111;
}
.article--item {
  display: grid;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  padding-left: 20px;
  padding-right: 15px;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1024px) and (max-width: 1264px) {
}
@media (min-width: 1020px) and (max-width: 1024px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}
@media (max-width: 600px) {
}
</style>
